var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class Dm8000 {
    constructor(socket, log) {
        this.socket = socket;
        this.blocks = [
            {
                instanceTag: 'AmplifierLevel',
                internalName: 'Control_Level_ganged',
                attributes: {
                    Muted: {
                        internalName: () => 'Level channel',
                        value: false,
                    },
                    Level_dB: {
                        internalName: () => 'Level value',
                        value: 0,
                    },
                },
            },
            {
                instanceTag: 'AssistiveListeningMute',
                internalName: 'Control_Level_ganged',
                attributes: {
                    Muted: {
                        internalName: () => 'Level channel',
                        value: false,
                    },
                    Level_dB: {
                        internalName: () => 'Level value',
                        value: 0,
                    },
                },
            },
            {
                instanceTag: 'AudioInputsMute',
                internalName: 'Control',
                attributes: {
                    Muted: {
                        internalName: () => 'Level channel',
                        value: [false, false, false, false],
                    },
                    Level_dB: {
                        internalName: () => 'Level value',
                        value: [0, 0, 0, 0],
                    },
                },
            },
            {
                instanceTag: 'Inputs',
                internalName: 'DM_Input_10_Channel',
                attributes: {
                    Input_Mute: {
                        internalName: (index) => `channel[${index}] input`,
                        value: [false, false, false, false, false, false, false, false, false, false],
                    },
                    Input_Level: {
                        internalName: (index) => `channel[${index}] input level`,
                        value: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                    },
                },
            },
            {
                instanceTag: 'MicsMute',
                internalName: 'Control_Level_ganged',
                attributes: {
                    Muted: {
                        internalName: () => 'Level channel',
                        value: false,
                    },
                    Level_dB: {
                        internalName: () => 'Level value',
                        value: 0,
                    },
                },
            },
            {
                instanceTag: 'Mixer',
                internalName: 'Mixer_Auto',
                attributes: {
                    Input_Mute: {
                        internalName: (index) => `channel[${index}] input`,
                        value: [false, false],
                    },
                    Input_Level: {
                        internalName: (index) => `channek[${index}] input level`,
                        value: [0, 0],
                    },
                },
            },
            {
                instanceTag: 'MuteControl',
                internalName: 'Control_Mute',
                attributes: {
                    Muted: {
                        internalName: () => 'channel',
                        value: [false, false],
                    },
                },
            },
            {
                instanceTag: 'Outputs',
                internalName: 'DM_Output_6_Channel',
                attributes: {
                    Output_Mute: {
                        internalName: (index) => `channel[${index}] output`,
                        value: [false, false, false, false, false, false],
                    },
                    Output_Level: {
                        internalName: (index) => `channel[${index}] output level`,
                        value: [0, 0, 0, 0, 0, 0],
                    },
                },
            },
            {
                instanceTag: 'OverflowRoomsMute',
                internalName: 'Control',
                attributes: {
                    Muted: {
                        internalName: () => 'Level channel',
                        value: [false, false, false, false],
                    },
                    Level_dB: {
                        internalName: () => 'Level value',
                        value: [0, 0, 0, 0],
                    },
                },
            },
        ];
        this.asyncHandlers = [
            {
                regExp: /^3rdStart$/i,
                callback: (match) => {
                    this.socket.send('@ok 3rd control start');
                },
            },
            {
                regExp: /^DEVICE\s+get\s+serialNumber$/i,
                callback: (match) => {
                    this.sendPitchCommandOkay();
                    this.socket.send('@ok Device Serial Number: S000000000000');
                },
            },
            {
                regExp: /^DEVICE\s+recallPreset\s+(.+)/,
                callback: (match) => {
                    this.socket.send('DEVICE recallPreset');
                },
            },
            {
                regExp: /^exit$/i,
                callback: (match) => {
                    this.socket.send('@ok 3rd control login off!!!');
                },
            },
            {
                regExp: /^get\s+(\S+)\s+(\S+)(?:\s+(\d+))?/i,
                callback: (match) => {
                    const [, alias, attrName, indexStr] = match;
                    const index = indexStr === undefined ? undefined : parseInt(indexStr, 10);
                    const block = this.findBlock(alias);
                    this.sendPitchCommandOkay();
                    if (block === undefined) {
                        this.sendError();
                        return;
                    }
                    const attr = this.findAttribute(block, attrName);
                    if (attr === undefined) {
                        this.socket.send(`@er Can't get valid attribute`);
                        this.sendPitchCommandFail();
                        return;
                    }
                    this.sendValueResponse(block, attr, index);
                },
            },
            {
                regExp: /^password\s+.+/,
                callback: (match) => {
                    this.socket.send('@ok Device Host Name DM8000');
                },
            },
            {
                regExp: /^SESSION\s+get\s+aliases/i,
                callback: (match) => {
                    const aliases = this.blocks.map(block => `"${block.instanceTag}"`);
                    this.sendPitchCommandOkay();
                    this.socket.send(`@ok Instance Tag Total: ${aliases.length}`);
                    this.socket.send(`@ok Instance Tag List:[${aliases.join(' ')}]`);
                },
            },
            {
                regExp: /^set\s+(\S+)\s+(\S+)(?:\s+(\d+))?\s+(\S+)/i,
                callback: (match) => {
                    const [, alias, attrName, indexStr, valueStr] = match;
                    const index = indexStr === undefined ? undefined : parseInt(indexStr, 10);
                    const block = this.findBlock(alias);
                    if (block === undefined) {
                        this.sendError();
                        return;
                    }
                    const attr = this.findAttribute(block, attrName);
                    if (attr === undefined) {
                        this.socket.send(`@er Can't set valid attribute`);
                        this.sendPitchCommandFail();
                        return;
                    }
                    if (index === undefined) {
                        if (typeof attr.value === 'boolean') {
                            attr.value = valueStr === '1';
                        }
                        else if (typeof attr.value === 'number') {
                            attr.value = parseFloat(valueStr);
                        }
                    }
                    else if (index !== undefined &&
                        Array.isArray(attr.value) &&
                        index >= 1 &&
                        index <= attr.value.length) {
                        if (typeof attr.value[index - 1] === 'boolean') {
                            attr.value[index - 1] = valueStr === '1';
                        }
                        else if (typeof attr.value[index - 1] === 'number') {
                            attr.value[index - 1] = parseFloat(valueStr);
                        }
                    }
                    this.sendValueResponse(block, attr, index);
                    this.sendPitchCommandOkay();
                },
            },
            {
                regExp: /^username\s+.+/,
                callback: (match) => {
                    // no response
                },
            },
            {
                regExp: /.+/,
                callback: (match) => {
                    this.sendError();
                },
            },
        ];
        this.commandExtractor = {
            terminators: ['\r', '\n'],
        };
        this.sendTerminator = '\r\n';
    }
    findAttribute(block, attrName) {
        for (const [key, value] of Object.entries(block.attributes)) {
            if (key === attrName)
                return value;
        }
        return undefined;
    }
    findBlock(alias) {
        return this.blocks.find(block => block.instanceTag === alias);
    }
    sendValueResponse(block, attr, index) {
        let resp = `@ok ${block.internalName}`;
        let value;
        if (Array.isArray(attr.value)) {
            if (index === undefined) {
                this.sendPitchCommandFail();
                return;
            }
            if (index < 1 || index > attr.value.length) {
                this.sendPitchCommandFail();
                this.socket.send(`@er index must be 1~${attr.value.length}`);
                return;
            }
            resp += ` ${attr.internalName(index)} is `;
            value = attr.value[index - 1];
        }
        else {
            resp += ` ${attr.internalName()} is `;
            value = attr.value;
        }
        if (typeof value === 'boolean') {
            resp += value ? 'mute' : 'unmute';
        }
        else {
            resp += `${value.toFixed(2)}dB`;
        }
        this.socket.send(resp);
    }
    sendError() {
        return __awaiter(this, void 0, void 0, function* () {
            // I don't know how the DM8000 really response to errors, so I'm using this as a catchall.
            return this.socket.send('@er invalid');
        });
    }
    sendPitchCommandFail() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.socket.send('@er pitch command fail !!!');
        });
    }
    sendPitchCommandOkay() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.socket.send('@ok pitch command okay !');
        });
    }
}
Dm8000.emulatorType = 'socketEmulator';
Dm8000.key = '-Ku0lpyEVxDpb7KUKfAb';
